import { useEffect, useState } from "react";

import { ThemeProvider } from "@material-ui/core/styles";
import i18n from "i18next";
import ReactGA from "react-ga";
import { Switch } from "react-router";
import { Route, BrowserRouter as Router, useLocation } from "react-router-dom";
import AuthApi from "./context/AuthApi";
import theme from "./theme";
// import { BorosThemeProvider } from "boros";
import { Redirect } from 'react-router-dom';
import AlertDialog from "./components/AlertDialog";
import Button from "./components/Button";
import { PrivateRoute } from "./components/PrivateRoute";
import Snackbar from "./components/Snackbar";
import { LanguageConfig } from "./config/Config";
import { CampaignProvider } from "./context/campaign";
import { NotificationProvider } from "./context/notification";
import { routeList, routes } from "./routes";
import { getLocalValue } from "./utils/auth";
import { getAllowedRoutes } from "./utils/getAllowedRoutes";

const TIME_OUT_TIME = 60;
const INACTIVITY_OUT_TIME = 60 * 5;

function App() {
  const location = useLocation();
  const [auth, setAuth] = useState(false);
  const [isCoach, setIsCoach] = useState(false);
  const [isCampaignAdmin, setIsCampaignAdmin] = useState(false);
  const [isCampaignCoord, setIsCampaignCoord] = useState(false);
  const [uid, setUid] = useState(null);
  const [allowedRoutes, setAllowRoutes] = useState([]);
  const [userCountry, setUserCountry] = useState(getLocalValue("region"));
  const [dialogOpen, setDialogOpen] = useState(false);
  const [timerVariable, setTimerVariable] = useState(TIME_OUT_TIME);
  const [timeout, setTimeout] = useState(0);
  const [timeoutTicker, setTimeoutTicker] = useState(0);
  const [timeRanOut, setTimeRanOut] = useState(false);

  const whitelist = [
    "/sessions/form/new",
    "/sessions/details/",
    "/sessions/grow/",
    "/sessions/grow/details/",
    "/sessions/set-checkpoints/",
    "/sessions/update-checkpoints/",
    "/sessions/review-summary/",
    "/sessions/coaching/",
    "/sessions/coaching/summary/",
    "/sessions/archive-session/",
    "/sessions/review-session/",
  ];
  let timeoutTickerInterval;

  const events = [
    "mousedown",
    "mousemove",
    "wheel",
    "keydown",
    "touchstart",
    "scroll",
    "keyup",
  ];

  const addListeners = (events, cb) => {
    events.forEach(event =>
      window.addEventListener(event, cb, { passive: true })
    );

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, cb, { passive: true })
      );
    };
  };
  useEffect(() => {
    clearInterval(timeout);

    addListeners(events, () => {
      setTimeoutTicker(0);
      clearInterval(timeoutTickerInterval);
      setTimerActivityVariableFunc(0);
    });
    setTimerActivityVariableFunc(0);
    // handleIdle(location.pathname);
  }, [location]);

  const setTimerActivityVariableFunc = timerActivityVariableClone => {
    timeoutTickerInterval = setInterval(() => {
      setTimeoutTicker(++timerActivityVariableClone);
    }, 1000);
  };

  useEffect(() => {
    if (timeoutTicker === INACTIVITY_OUT_TIME) {
      handleIdle();
    }
  }, [timeoutTicker]);

  const handleIdle = pathname => {
    setTimerVariable(TIME_OUT_TIME);
    clearInterval(timeout);
    console.log(
      'location.pathname.replace(/[0-9]/g, "").replace("//", "/")',
      location.pathname.replace(/[0-9]/g, "").replace("//", "/")
    );
    if (
      whitelist.includes(
        location.pathname.replace(/[0-9]/g, "").replace("//", "/")
      )
    ) {
      setDialogOpen(true);
      clearInterval(timeout);
      runsTheTimerForDialog(timerVariable);
    }
    return;
  };

  const runsTheTimerForDialog = timerVariable => {
    setTimeout(
      setInterval(() => {
        if (timerVariable === 0) {
          logOutPrompt();
        } else {
          setTimerVariable(--timerVariable);
        }
      }, 1000)
    );
  };

  // useEffect(() => {
  //   if (timerVariableClone === 0) {
  //     logOut();
  //   } else {
  //     setTimerVariable(--timerVariableClone);
  //   }
  // }, [timerVariable])

  const stayOnTheApp = () => {
    setTimerVariable(TIME_OUT_TIME);
    clearInterval(timeout);
    setDialogOpen(false);
  };

  useEffect(() => {
    setAllowRoutes(getAllowedRoutes(routeList));
    setUserCountry(getLocalValue("region"));
  }, [auth, isCoach, uid]);

  useEffect(() => {
    i18n.changeLanguage(LanguageConfig[userCountry]);
  }, [userCountry]);

  useEffect(() => {
    ReactGA.initialize("UA-150404410-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  });

  const logOutPrompt = () => {
    setTimerVariable(TIME_OUT_TIME);
    clearInterval(timeout);
    setTimeRanOut(true);
  };

  const performLogOut = () => {
    localStorage.removeItem("access_token");
    sessionStorage.clear();
    // history.push('/');
    window.location = "/"; // Need to clear the react context after logout.
  };

  if (
    process.env.REACT_APP_MAINTENANCE_MODE === "true" &&
    location.pathname !== routes.maintenance.path
  ) {
    return <Redirect to={routes.maintenance.path} />;
  }

  return (
    <AuthApi.Provider
      value={{
        auth,
        setAuth,
        isCoach,
        setIsCoach,
        isCampaignAdmin,
        setIsCampaignAdmin,
        isCampaignCoord,
        setIsCampaignCoord,
        uid,
        setUid,
      }}
    >
      <ThemeProvider theme={theme}>
        <NotificationProvider>
          <CampaignProvider>
            <AlertDialog
              open={dialogOpen}
              title={
                timeRanOut
                  ? `Session timed out`
                  : `Your session is about to expire`
              }
              body={
                timeRanOut ? (
                  <>
                    <p>Your session is about to expire due to inactivity</p>
                  </>
                ) : (
                  <>
                    <p>Your session is about to expire due to inactivity</p>
                    <p>Time Remaining {timerVariable} seconds</p>
                  </>
                )
              }
              footer={
                timeRanOut ? (
                  <>
                    <Button
                      style={{
                        backgroundColor: "#e35646",
                        color: "white",
                      }}
                      onClick={() => {
                        setDialogOpen(false);
                        performLogOut();
                      }}
                    >
                      Login again
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      onClick={() => {
                        setDialogOpen(false);
                        performLogOut();
                      }}
                    >
                      Logout now
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#e35646",
                        color: "white",
                      }}
                      onClick={() => stayOnTheApp()}
                    >
                      Stay Logged in
                    </Button>
                  </>
                )
              }
            />
            <Router>
              <Switch>
                {allowedRoutes.map((route, index) => {
                  if (route.isPublic) {
                    return (
                      <Route
                        exact={route.exact}
                        path={route.path}
                        key={index}
                        title={route.title}
                      >
                        {route.component}
                      </Route>
                    );
                  } else if (!route.isPublic) {
                    return (
                      <PrivateRoute
                        exact={route.exact}
                        path={route.path}
                        key={index}
                      >
                        {route.component}
                      </PrivateRoute>
                    );
                  } else {
                    console.error("Route list mapping error. Check src/App.js");

                    return null;
                  }
                })}
              </Switch>
            </Router>
            <Snackbar />
          </CampaignProvider>
        </NotificationProvider>
      </ThemeProvider>
    </AuthApi.Provider>
  );
}
export default App;

